import React, { useEffect, useState } from 'react'

import Card from "@mui/material/Card";

import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'
import MDButton from 'components/MDButton'
import MDInput from 'components/MDInput'

import DateTimePicker from 'react-datetime-picker'
import CreateAppointmentRequestReq from '../../../../Classes/Models/Requests/Appointments/CreatePatientAppointmentRequestReq'
import Swal from 'sweetalert2';

import AppointmentsApi from 'Classes/API/Appointments/AppointmentsApi';
const AppointmentRequestCard = ({Session}) => {

    const [FirstPriorityTime, setFirstPriorityTime] = useState(new Date())
    const [SecondPriorityTime, setSecondPriorityTime] = useState(new Date())
    const [ThirdPriorityTime, setThirdPriorityTime] = useState(new Date())
    const [Notes, setNotes] = useState("");

    const onSubmit = async () => {
        let createAppointmentRequestReq = new CreateAppointmentRequestReq();
        createAppointmentRequestReq.AccountingSessionId = Session.id;
        createAppointmentRequestReq.FirstPrioTime = FirstPriorityTime;
        createAppointmentRequestReq.SecondPrioTime = SecondPriorityTime;
        createAppointmentRequestReq.ThirdPrioTime = ThirdPriorityTime;

        createAppointmentRequestReq.Notes = Notes;
        createAppointmentRequestReq.PatientId = Session.getPatient.id;

        console.log(createAppointmentRequestReq);
        let res = await AppointmentsApi.CreatePatientAppointmentRequest(createAppointmentRequestReq);
        console.log(res);
        if (res.status == "Success") {

            Swal.fire({
                title: 'Success',
                text: res.message,
                icon: 'success',
                confirmButtonText: 'OK'
            })

        } else {
            Swal.fire({
                title: 'Error',
                text: res.message,
                icon: 'error',
                confirmButtonText: 'OK'
            })
        }

        

    }

    return (
        <Card  sx={{ height: "100%", boxShadow: !false && "none", marginTop:"2em", padding: "1em" }}>
            <MDBox sx={{ p: 2 }}>

                <MDBox sx={{ display: "flex", justifyContent: "space-between", marginTop:"1em" }}>
                    <MDTypography variant="h6">
                        Create Appointment Request
                    </MDTypography>
                    <MDButton onClick={() => onSubmit()} variant="contained" color="primary">
                        Save
                    </MDButton>
                </MDBox>
            </MDBox>
            
            <MDBox sx={{ display: "flex", justifyContent: "space-between", marginTop:"1em" }}>
                <MDTypography variant="h6">
                    First Priority Time: 
                </MDTypography>
                <DateTimePicker  
                value={FirstPriorityTime}
                onChange={setFirstPriorityTime}/>
            </MDBox>


            <MDBox sx={{ display: "flex", justifyContent: "space-between", marginTop:"1em", }}>
                <MDTypography variant="h6">
                    Second Priority Time: 
                </MDTypography>
                <DateTimePicker
                value={SecondPriorityTime}
                onChange={setSecondPriorityTime}/>
            </MDBox>


            <MDBox sx={{ display: "flex", justifyContent: "space-between" , marginTop:"1em",}}>
                <MDTypography variant="h6">
                    Third Priority Time: 
                </MDTypography>
                <DateTimePicker 
                value={ThirdPriorityTime}
                onChange={setThirdPriorityTime}/>
            </MDBox>

            <MDBox sx={{ display: "flex", justifyContent: "space-between" , marginTop:"1em",}}>
                <MDTypography mr={2} variant="h6">
                    Notes:
                </MDTypography>
                <textarea className="full-width"
                onChange={(e) => setNotes(e.target.value)}/>
            </MDBox>

        </Card>
  )
}

export default AppointmentRequestCard